// Centralized helper for default OSD tracking headers
// Reference: Common headers used in API files in src/API

import { ApiType } from "./Types";

// Map of ApiType to default headers, similar to getUrl
export const getTrackingHeadersMap = (
  apiType: ApiType,
): Record<string, string> => {
  const headers: { [key in ApiType]: Record<string, string> } = {
    [ApiType.TERMINAL]: {
      "Content-Type": "application/json",
    },
    [ApiType.VALIDATE_OKTA_TOKEN]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "dashboard",
      "OSD-Section-Name": "header",
      "OSD-Action-Type": "login",
    },
    [ApiType.CLEARING_CODES]: {
      "Content-Type": "application/json",
    },
    [ApiType.EXCEPTIONS_LIST]: {
      "Content-Type": "application/json",
      
    },
    [ApiType.GET_MISDELIVERY]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
      "OSD-Exception-Type": "MSD",
    },
    [ApiType.OVERAGE_FILTER_MASTER_USER]: {
      "Content-Type": "application/json",
    },
    [ApiType.EXCEPTION_ASSIGN]: {
      "Content-Type": "application/json",
    },
    [ApiType.EXCEPTION_DETAILS]: {
      "Content-Type": "application/json",
    },
    [ApiType.PRO_IMAGES]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "proImages",
      "OSD-Action-Type": "list",
    },
    [ApiType.MASTER_RECORDS]: {
      "Content-Type": "application/json",
    },
    [ApiType.MANIFEST_DETAILS]: {
      "Content-Type": "application/json",
    },
    [ApiType.MANIFEST_PRO_DETAILS]: {
      "Content-Type": "application/json",
    },
    [ApiType.SEND_APB_MAIL]: {
      "Content-Type": "application/json",
      "OSD-Action-Type": "send",
    },
    [ApiType.SEND_MAIL]: {
      "Content-Type": "application/json",
    },
    [ApiType.MASTER_PRO_NUMBER]: {
      "Content-Type": "application/json",
    },
    [ApiType.MASTER_OSD_NUMBER]: {
      "Content-Type": "application/json",
    },
    [ApiType.COMMODITY_TYPE_MASTER]: {
      "Content-Type": "application/json",
    },
    [ApiType.LOCATION_MASTER]: {
      "Content-Type": "application/json",
    },
    [ApiType.EXCEPTION_CODE_MASTER]: {
      "Content-Type": "application/json",
    },
    [ApiType.CHECK_PRO]: {
      "Content-Type": "application/json",
    },
    [ApiType.DEPLOYMENT_STATUS]: {
      "Content-Type": "application/json",
    },
    [ApiType.OVERAGE_UPDATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "entry",
      "OSD-Action-Type": "save",
    },
    [ApiType.DS_ENTRY_UPDATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "DS",
      "OSD-Action-Type": "save",
    },
    [ApiType.OVERAGE_ENTRY_DETAILS]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
    },
    [ApiType.DS_ENTRY_DETAILS]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
      "OSD-Exception-Type": "DS",
    },
    [ApiType.SAVE_OR_SUBMIT_INVESTIGATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "investigation",
    },
    [ApiType.UPLOAD_FILE]: {
      "Content-Type": "application/json",
    },
    [ApiType.DOC_TYPE]: {
      "Content-Type": "application/json",
    },
    [ApiType.SAVE_OR_SUBMIT_DS_INVESTIGATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "investigation",
      "OSD-Exception-Type": "DS",
    },
    [ApiType.SEND_DISPOSITION_DATA]: {
      "Content-Type": "application/json",
    },
    [ApiType.LOGGLY_LOG]: {
      "Content-Type": "application/json",
    },
    [ApiType.REFUSAL_ENTRY_DETAILS]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "damagesOrRefusals",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
    },
    [ApiType.UPDATE_EXCEPTION_LOCATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "dataTable",
      "OSD-Action-Type": "save",
    },
    [ApiType.MSD_VIEW]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
      "OSD-Exception-Type": "MSD",
    },
    [ApiType.MSD_IVESTIGATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "investigation",
      "OSD-Action-Type": "save", // or dynamic
      "OSD-Exception-Type": "MSD",
    },
    [ApiType.PICKUP_DETAILS]: {
      "Content-Type": "application/json",
    },
    [ApiType.MISDELIVERY_VALIDATE_BOL_PRO]: {
      "Content-Type": "application/json",
    },
    [ApiType.UN_NA_NUMBERS]: {
      "Content-Type": "application/json",
    },
    [ApiType.DASHBOARD_KRA]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "dashboard",
      "OSD-Section-Name": "exceptionSummary",
      "OSD-Action-Type": "list",
    },
    [ApiType.BNF_EDIT_VIEW]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "viewEdit",
      "OSD-Exception-Type": "BNF",
      "OSD-Action-Type": "get",
    },
    [ApiType.AS_ENTRY_DETAILS]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
      "OSD-Exception-Type": "AS",
    },
    [ApiType.REFUSAL_FOLLOWUP]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "damagesOrRefusals",
      "OSD-Section-Name": "followup",
      "OSD-Action-Type": "save", // or dynamic
      // "OSD-Exception-Type" and "OSD-Exception-Number" are dynamic
    },
    [ApiType.MSD_NOTES]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "MSD",
      "OSD-Action-Type": "get",
    },
    [ApiType.SHORTAGE_ENTRY_CREATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "AS",
      "OSD-Action-Type": "submit",
    },
    [ApiType.OVERAGE_CREATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "OH", // or dynamic
      "OSD-Action-Type": "submit",
    },
    [ApiType.ON_HAND_ENTRY_CREATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "onHand",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "OH",
      "OSD-Action-Type": "submit",
    },
    [ApiType.REFUSAL_ENTRY_UPDATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "damagesOrRefusals",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "save",
    },
    [ApiType.SHORTAGE_INVESTIGATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "investigation",
      "OSD-Exception-Type": "AS",
      "OSD-Action-Type": "save", // or dynamic
    },
    [ApiType.ON_HAND_INVESTIGATION]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "onHand",
      "OSD-Section-Name": "investigation",
      "OSD-Exception-Type": "OH",
      "OSD-Action-Type": "save", // or dynamic
    },
    [ApiType.ON_HAND_FOLLOWUP]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "onHand",
      "OSD-Section-Name": "followup",
      "OSD-Exception-Type": "OH",
      "OSD-Action-Type": "save", // or dynamic
    },
    [ApiType.MISDELIVERY_BOL]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "bol",
      "OSD-Action-Type": "save",
      "OSD-Exception-Type": "MSD",
    },
    [ApiType.BNF_FOLLOWUP]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "bnfFollowup",
      "OSD-Exception-Type": "BNF",
      "OSD-Action-Type": "submit",
      // "OSD-Exception-Number" is dynamic
    },
    [ApiType.MISDELIVERY_CREATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "misdelivery",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "MSD",
      "OSD-Action-Type": "submit",
    },
    [ApiType.AS_ENTRY_UPDATE]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "shortages",
      "OSD-Section-Name": "entry",
      "OSD-Exception-Type": "AS",
      "OSD-Action-Type": "save",
    },
    [ApiType.ON_HAND_VIEW]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "onHand",
      "OSD-Section-Name": "viewEdit",
      "OSD-Action-Type": "get",
      "OSD-Exception-Type": "OH",
    },
    [ApiType.PRINT]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "overages",
      "OSD-Section-Name": "entry",
      "OSD-Action-Type": "submit",
      // "OSD-Exception-Number" is dynamic
    },
    [ApiType.LOGOUT]: {
      "Content-Type": "application/json",
      "OSD-Module-Name": "dashboard",
      "OSD-Section-Name": "header",
      "OSD-Action-Type": "logout",
    },
  };

  return headers[apiType];
};

// Usage:
// const headers = getTrackingHeadersMap(ApiType.MISDELIVERY_BOL);
